import { Component, OnInit, OnChanges, SimpleChange, ViewChild, Input, TemplateRef, Output, EventEmitter, Renderer2, OnDestroy, AfterViewInit, inject } from '@angular/core';
import { CustomDialogOptions } from './custom-dialog';

import * as _ from 'lodash';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';

import { trigger, transition, style, animate, state } from '@angular/animations';
import { ViewportScroller } from '@angular/common';
import { GlobalService } from 'src/app/services/global.service';
import { MatDialog, matDialogAnimations, MatDialogContent } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-custom-dialog',
    templateUrl: './custom-dialog.component.html',
    styleUrls: ['./custom-dialog.component.scss'],
    animations: [
        trigger('fadeInOutWithBlur', [
            transition(':enter', [
                style({ 'backdrop-filter': 'blur(0px) brightness(1)' }),
                animate('150ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ 'backdrop-filter': 'blur(24px) brightness(.75)' })),
            ]),
            transition(':leave', [
                style({ 'backdrop-filter': 'blur(24px) brightness(.75)', 'opacity': 1, 'filter': ' blur(0)', }),
                animate('200ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ 'backdrop-filter': 'blur(0px) brightness(1)', 'opacity': 0, 'filter': ' blur(40px)', })),
            ])
        ]),
        trigger('dialogAnimation', [
            state('false', style({ 'opacity': 0 })),
            state('true', style({ 'opacity': 1 })),
            transition('false => true', animate('150ms cubic-bezier(0.25, 0.1, 0.25, 1)')),
            transition('true => false', animate('200ms cubic-bezier(0.25, 0.1, 0.25, 1)'))
        ]),
    ],
    standalone: false
})
export class CustomDialogComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  // view html elements 
  //@ViewChild(DialogComponent) dialog: any;

  // require data in Input when calling this component
  @Input() options: CustomDialogOptions | undefined;
  @Input() dialogHeaderTExt: string | undefined;

  // emite output value
  @Output() beforeDialogOpen: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterDialogOpen: EventEmitter<any> = new EventEmitter<any>();
  @Output() beforeDialogClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterDialogClose: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('content', { static: true }) content: TemplateRef<any> | undefined;

  dialogAnimation: Object = { effect: 'None', duration: 0, delay: 0 };

  parsedOptions: CustomDialogOptions = {
    height: 'auto',
    width: '95vw',
    closeOnEscape: true,
    visible: false,
    showCloseIcon: true,
    isModal: true,
    animationSettings: this.dialogAnimation,
  };
  targetElement!: HTMLElement;

  private theEnd$ = new Subject<void>();


  height: string = 'auto';
  width: string = '95vw';
  closeOnEscape: boolean = true;
  visible: boolean = false;
  showCloseIcon: boolean = true;
  isModal: boolean = false;
  status: boolean = false;
  show: boolean = false;
  closeOnOutside: boolean = false;

  init: boolean = true;

  dialogHeaderTextParsed: string = '';
  scrollPosition: number = 0;
  private unlisten: (() => void) | undefined;


  readonly dialog = inject(MatDialog);

  constructor(
    private deviceS: BrowserDetectorService,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private scroller: ViewportScroller
  ) {
    /*this.parsedOptions.height = 'auto';
    this.parsedOptions.width = '95vw';
    this.parsedOptions.closeOnEscape = true;
    this.parsedOptions.visible = false;
    this.parsedOptions.showCloseIcon = true;
    this.parsedOptions.isModal = true;
    this.parsedOptions.animationSettings = this.dialogAnimation;
    console.error(this.parsedOptions);
    this.parseOptions(this.parsedOptions);*/
  }

  ngOnInit(): void {
    console.error('INIT')
    console.error(this.status)
    console.error(this.show)
    if (this.status && this.show) {
      this.blockScroll(false)
    }



    if (this.options != undefined) {
      this.parseOptions(this.options);
    }
    if (this.dialogHeaderTExt != undefined) {
      this.parseHeaderText(this.dialogHeaderTExt);
    }

    // Add the click event listener on the document
    this.unlisten = this.renderer.listen('document', 'click', (event: any) => {
      if (this.closeOnOutside == true) {
        if (event.target.className == 'e-dlg-overlay') {
          this.close();
        }
      }
    });

    this.dialog.afterAllClosed.pipe(takeUntil(this.theEnd$)).subscribe(() =>{
      this.afterDialogClose.emit();
    })
  }

  ngOnDestroy(): void {
    console.log("DESTROY")
    //this.blockScroll(true);
    if (this.unlisten) {
      this.unlisten();
    }

        this.theEnd$.next();
    this.theEnd$.complete();
  }


  ngOnChanges(changes: { options: SimpleChange, dialogHeaderTExt: SimpleChange }): void {
    if (changes.options) {
      this.parseOptions(changes.options.currentValue);
    }
    if (changes.dialogHeaderTExt) {
      this.parseHeaderText(changes.dialogHeaderTExt.currentValue);
    }
  }



  ngAfterViewInit(): void {
    /*document.onclick = (args: any) : void => {      
      if(args.target.className == 'e-dlg-overlay') {
          this.close();
      }
    }*/
  }

  /**
   * open the dialog
   */
  open(): void {

    this.beforeDialogOpen.emit();
    this.status = true;


    this.show = true;
    if (this.content)
      this.dialog.open(this.content, {
        minWidth: '90vw',
      
        width: '90vw',
      
    });


    /*   setTimeout(() => {
        this.blockScroll(false);
      }, 100); */

    this.afterDialogOpen.emit();
    //this.dialog?.show();


  }

  /**
   * Close the dialog
   */
  close(): void {

    this.beforeDialogClose.emit();
    /* this.blockScroll(true); */

    setTimeout(() => {

      this.show = false;
      this.show = false;

      this.status = false;

      this.afterDialogClose.emit();

      this.dialog.closeAll();
    }, 100);




  }

  /**
   * event called before the dialog is opened
   * turn e.cancel = true; to abort the dialog open action
   * @param e cancel: the only thing that you will need
   */
  beforeOpen(e: any) {
    this.beforeDialogOpen.emit(e);

  }

  /**
   * event called after the dialog is fully open
   * @param e preventFocus: boolean the only usefull stuff
   */
  afterOpen(e: any) {
    this.afterDialogOpen.emit(e);
    this.status = true;
  }

  /**
   * event called before the dialog is close
   * turn e.cancel = true; to abort the dialog close action
   * @param e cancel: boolean, isInteracted: boolean this are the only usefull data
   */
  beforeClose(e: any) {
    this.beforeDialogClose.emit(e);

  }


  /**
   * event called after the dialog is closed
   * there is e.canel but changing it won't make any difference
   * @param e nothing usefell
   */
  afterClose(e: any) {
    this.afterDialogClose.emit(e);
    this.status = false;

  }


  parseHeaderText(value: string) {
    this.dialogHeaderTextParsed = value;
  }

  parseOptions(options: CustomDialogOptions) {
    this.parsedOptions = _.cloneDeep(options);
    if (options.height != undefined) {
      this.height = options.height;
    }
    if (options.width != undefined) {
      this.width = options.width;
    }
    if (options.animationSettings != undefined) {
      this.dialogAnimation = options.animationSettings;
    }
    if (options.closeOnEscape != undefined) {
      this.closeOnEscape = options.closeOnEscape;
    }
    if (options.visible != undefined) {
      this.visible = options.visible;
    }
    if (options.isModal != undefined) {
      this.isModal = options.isModal;
    }
    if (options.showCloseIcon != undefined) {
      this.showCloseIcon = options.showCloseIcon;
    }
    if (options.closeOnOutsideClick != undefined) {
      this.closeOnOutside = options.closeOnOutsideClick;
    }
  }



  blockScroll(block: boolean) {
    this.scrollPosition = window.scrollY;
    console.warn(this.scrollPosition)

    if (block == false) {
      console.log('ITS OPEN')

      document.body.style.width = '100%';
      document.body.style.height = '100vh';
      document.body.style.margin = '0';
      document.body.style.overflow = 'hidden';

    } else {
      console.log('ITS CLOSED')
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.margin = '';
      document.body.style.overflow = '';

    }
  }

}
